import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import queryString from 'query-string';
import cx from 'classnames';
import Input from '../Forms/Input';
import PasswordInput from '../Forms/PasswordInput';
import FormError from '../Forms/FormError';
import Button from '../Button';
import FlatButton from '../FlatButton';
import issueWithRedirectError from '../../utils/issue-with-redirect-error';
import styles from './LoginForm.css';


const LoginForm = ({
    handleSubmit,
    pristine,
    submitting,
    error,
    autoFillEmail,
}) => (<div
    className={styles.container}
>
    <form onSubmit={handleSubmit}>
        <h1>Login</h1>
        <p>Enter your information below.</p>
        <FormError
            style={{ textAlign: 'center' }}
            error={issueWithRedirectError(error)}
        />
        <Field
            name="userName"
            label="Email"
            component={Input}
            className={cx(styles.userName, {
                [styles.disabled]: !!autoFillEmail,
            })}
            disabled={!!autoFillEmail}
        />
        <Field
            name="password"
            label="Password"
            component={PasswordInput}
        />
        <FlatButton
            to={`/forget-password${autoFillEmail ? `?email=${encodeURIComponent(autoFillEmail)}` : ''}`}
            className={styles.forgetPasswordLink}
        >
            Forgot Password?
        </FlatButton>
        <div style={{ textAlign: 'center' }}>
            <Button
                type="submit"
                disabled={pristine}
                loading={submitting}
            >
                LOGIN
            </Button>
        </div>
    </form>
</div>);


LoginForm.propTypes = {
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    error: PropTypes.string,
    autoFillEmail: PropTypes.string,
};

export default compose(
    withRouter,
    connect((state, { location }) => {
        let autoFillEmail = '';
        const query = queryString.parse(location.search);
        if (query.email) {
            autoFillEmail = query.email;
        }
        return {
            initialValues: {
                password: '',
                userName: autoFillEmail,
            },
            autoFillEmail,
        };
    }),
    reduxForm({
        form: 'login',
    }),
)(LoginForm);



// WEBPACK FOOTER //
// ./src/client/Components/LoginForm/LoginForm.js